import styled from 'styled-components';
import {Button} from '@mui/material';
import {media, theme} from '../../../theme';

export const Description = styled.p`
    width: 100%;
    margin: 0;
    text-align: center;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.02em;
    color: ${({theme}) => theme.palette.text.primary};

    ${media.sm} {
        font-size: 15px;
        line-height: 22px;
    }
`;

export const EmailText = styled.span`
    font-weight: 700;
    color: ${theme.palette.text.primary};
`;

export const FieldHint = styled.p`
    margin: 4px 0 0 0;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    color: ${({theme}) => theme.palette.text.hint};
`;

export const BackButton = styled(Button)`
    && {
        width: 100%;
        min-height: 24px;
        padding: 0;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: -0.02em;
        color: ${theme.palette.text.primary};
        text-transform: none;
        text-decoration: underline;

        &:hover {
            background: transparent;
            text-decoration: none;
        }
    }
`;
